var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 17H5L15.5 6.5C15.7626 6.23735 15.971 5.92555 16.1131 5.58239C16.2553 5.23923 16.3284 4.87143 16.3284 4.5C16.3284 4.12856 16.2553 3.76077 16.1131 3.4176C15.971 3.07444 15.7626 2.76264 15.5 2.5C15.2374 2.23735 14.9256 2.02901 14.5824 1.88687C14.2392 1.74473 13.8714 1.67157 13.5 1.67157C13.1286 1.67157 12.7608 1.74473 12.4176 1.88687C12.0744 2.02901 11.7626 2.23735 11.5 2.5L1 13V17Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.0415df530645d1227f0157e09df1eba3.svg";
export { ForwardRef as ReactComponent };